import * as React from 'react';
import { VerticalBarGraphItemV2 } from '@leagueplatform/dashboard-api';
import { InsightCardVerticalBarGraphV2 } from '@leagueplatform/dashboard';

function generateAriaLabel(items: VerticalBarGraphItemV2[]) {
  const ariaLabel = items
    .map((item) => `${item.indexLabel} ${item.indexValue}`)
    .join('; ');
  return ariaLabel;
}

type VerticalBarGraphInsightResponse = {
  items: VerticalBarGraphItemV2[];
  description: string;
};

export function VerticalBarGraphInsightNodeRenderer({
  description,
  items,
}: VerticalBarGraphInsightResponse) {
  const ariaLabel = generateAriaLabel(items);

  return (
    <InsightCardVerticalBarGraphV2
      title={description}
      description={ariaLabel}
      items={items}
    />
  );
}
